import makePlural from "../makePlural";
import makeSingular from "../makeSingular";
import { NEW_LINE, TAB_SPACE } from "./constants";
import getReduxTypesImports from "./getReduxTypesImports";

export default function getReduxActions(params) {
  const singularModuleName = makeSingular(params.module);
  let reduxActions = "";

  // Start import **
  reduxActions += `import {${
    NEW_LINE + TAB_SPACE + getReduxTypesImports(params).join(NEW_LINE + TAB_SPACE) + NEW_LINE
  }} from './${singularModuleName.toLowerCase()}Types';`;
  // ** End import

  if (params?.features === "rw" || params?.features === "r") {
    reduxActions += NEW_LINE + NEW_LINE;
    reduxActions += getReduxFetchAllActions(params);
    reduxActions += NEW_LINE + NEW_LINE;
    reduxActions += getReduxFetchSingleActions(params);
  }

  if (params?.features === "rw" || params?.features === "w") {
    reduxActions += NEW_LINE + NEW_LINE;
    reduxActions += getReduxCreateActions(params);
    reduxActions += NEW_LINE + NEW_LINE;
    reduxActions += getReduxUpdateActions(params);
    reduxActions += NEW_LINE + NEW_LINE;
    reduxActions += getReduxDeleteActions(params);
  }

  return reduxActions;
}

function getReduxFetchAllActions(params) {
  const pruralModuleName = makePlural(params.module);
  let reduxActions = "";

  // Start fetch all
  reduxActions += `export const fetchAll${capitalizeFirstLetter(pruralModuleName)} = () => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return (dispatch) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}dispatch(fetchAll${capitalizeFirstLetter(pruralModuleName)}Request());`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}axios`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}.get('${params.apiUrls}')`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}.then((response) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}const ${pruralModuleName} = response.data;`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}dispatch(fetchAll${capitalizeFirstLetter(
    pruralModuleName
  )}Success(${pruralModuleName}));`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}})`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}.catch((error) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}dispatch(fetchAll${capitalizeFirstLetter(
    pruralModuleName
  )}Failure(error.message));`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}})`;
  reduxActions += `${NEW_LINE + TAB_SPACE}};`;
  reduxActions += `${NEW_LINE}};`;

  reduxActions += NEW_LINE + NEW_LINE;

  reduxActions += `const fetchAll${capitalizeFirstLetter(pruralModuleName)}Request = () => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}type: FETCH_ALL_${pruralModuleName.toUpperCase()}_REQUEST,`;
  reduxActions += `${NEW_LINE + TAB_SPACE}}`;
  reduxActions += `${NEW_LINE}};`;

  reduxActions += NEW_LINE + NEW_LINE;

  reduxActions += `const fetchAll${capitalizeFirstLetter(pruralModuleName)}Success = (${pruralModuleName}) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}type: FETCH_ALL_${pruralModuleName.toUpperCase()}_SUCCESS,`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}payload: ${pruralModuleName},`;
  reduxActions += `${NEW_LINE + TAB_SPACE}}`;
  reduxActions += `${NEW_LINE}};`;

  reduxActions += NEW_LINE + NEW_LINE;

  reduxActions += `const fetchAll${capitalizeFirstLetter(pruralModuleName)}Failure = (error) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}type: FETCH_ALL_${pruralModuleName.toUpperCase()}_FAILURE,`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}payload: error,`;
  reduxActions += `${NEW_LINE + TAB_SPACE}}`;
  reduxActions += `${NEW_LINE}};`;
  // End fetch all

  return reduxActions;
}

function getReduxFetchSingleActions(params) {
  const singularModuleName = makeSingular(params.module);
  let reduxActions = "";

  // Start fetch single
  reduxActions += `export const fetchSingle${capitalizeFirstLetter(singularModuleName)} = (id) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return (dispatch) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}dispatch(fetchSingle${capitalizeFirstLetter(singularModuleName)}Request());`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}axios`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}.get('${params.apiUrls}/' + id)`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}.then((response) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}const ${singularModuleName} = response.data;`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}dispatch(fetchSingle${capitalizeFirstLetter(
    singularModuleName
  )}Success(${singularModuleName}));`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}})`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}.catch((error) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}dispatch(fetchSingle${capitalizeFirstLetter(
    singularModuleName
  )}Failure(error.message));`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}})`;
  reduxActions += `${NEW_LINE + TAB_SPACE}};`;
  reduxActions += `${NEW_LINE}};`;

  reduxActions += NEW_LINE + NEW_LINE;

  reduxActions += `const fetchSingle${capitalizeFirstLetter(singularModuleName)}Request = () => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}type: FETCH_SINGLE_${singularModuleName.toUpperCase()}_REQUEST,`;
  reduxActions += `${NEW_LINE + TAB_SPACE}}`;
  reduxActions += `${NEW_LINE}};`;

  reduxActions += NEW_LINE + NEW_LINE;

  reduxActions += `const fetchSingle${capitalizeFirstLetter(singularModuleName)}Success = (${singularModuleName}) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}type: FETCH_SINGLE_${singularModuleName.toUpperCase()}_SUCCESS,`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}payload: ${singularModuleName},`;
  reduxActions += `${NEW_LINE + TAB_SPACE}}`;
  reduxActions += `${NEW_LINE}};`;

  reduxActions += NEW_LINE + NEW_LINE;

  reduxActions += `const fetchSingle${capitalizeFirstLetter(singularModuleName)}Failure = (error) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}type: FETCH_SINGLE_${singularModuleName.toUpperCase()}_FAILURE,`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}payload: error,`;
  reduxActions += `${NEW_LINE + TAB_SPACE}}`;
  reduxActions += `${NEW_LINE}};`;
  // End fetch single

  return reduxActions;
}

function getReduxCreateActions(params) {
  const singularModuleName = makeSingular(params.module);
  let reduxActions = "";

  // Start fetch create
  reduxActions += `export const create${capitalizeFirstLetter(singularModuleName)} = () => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return (dispatch) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}dispatch(create${capitalizeFirstLetter(singularModuleName)}Request());`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}axios`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}.post('${params.apiUrls}')`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}.then((response) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}const message = response.data;`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}dispatch(create${capitalizeFirstLetter(
    singularModuleName
  )}Success(message));`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}})`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}.catch((error) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}dispatch(create${capitalizeFirstLetter(
    singularModuleName
  )}Failure(error.message));`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}})`;
  reduxActions += `${NEW_LINE + TAB_SPACE}};`;
  reduxActions += `${NEW_LINE}};`;

  reduxActions += NEW_LINE + NEW_LINE;

  reduxActions += `const create${capitalizeFirstLetter(singularModuleName)}Request = () => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}type: CREATE_${singularModuleName.toUpperCase()}_REQUEST,`;
  reduxActions += `${NEW_LINE + TAB_SPACE}}`;
  reduxActions += `${NEW_LINE}};`;

  reduxActions += NEW_LINE + NEW_LINE;

  reduxActions += `const create${capitalizeFirstLetter(singularModuleName)}Success = (${singularModuleName}) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}type: CREATE_${singularModuleName.toUpperCase()}_SUCCESS,`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}payload: ${singularModuleName},`;
  reduxActions += `${NEW_LINE + TAB_SPACE}}`;
  reduxActions += `${NEW_LINE}};`;

  reduxActions += NEW_LINE + NEW_LINE;

  reduxActions += `const create${capitalizeFirstLetter(singularModuleName)}Failure = (error) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}type: CREATE_${singularModuleName.toUpperCase()}_FAILURE,`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}payload: error,`;
  reduxActions += `${NEW_LINE + TAB_SPACE}}`;
  reduxActions += `${NEW_LINE}};`;
  // End fetch create

  return reduxActions;
}

function getReduxUpdateActions(params) {
  const singularModuleName = makeSingular(params.module);
  let reduxActions = "";

  // Start fetch update
  reduxActions += `export const update${capitalizeFirstLetter(singularModuleName)} = (id) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return (dispatch) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}dispatch(update${capitalizeFirstLetter(singularModuleName)}Request());`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}axios`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}.put('${params.apiUrls}/' + id)`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}.then((response) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}const message = response.data;`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}dispatch(update${capitalizeFirstLetter(
    singularModuleName
  )}Success(message));`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}})`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}.catch((error) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}dispatch(update${capitalizeFirstLetter(
    singularModuleName
  )}Failure(error.message));`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}})`;
  reduxActions += `${NEW_LINE + TAB_SPACE}};`;
  reduxActions += `${NEW_LINE}};`;

  reduxActions += NEW_LINE + NEW_LINE;

  reduxActions += `const update${capitalizeFirstLetter(singularModuleName)}Request = () => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}type: UPDATE_${singularModuleName.toUpperCase()}_REQUEST,`;
  reduxActions += `${NEW_LINE + TAB_SPACE}}`;
  reduxActions += `${NEW_LINE}};`;

  reduxActions += NEW_LINE + NEW_LINE;

  reduxActions += `const update${capitalizeFirstLetter(singularModuleName)}Success = (${singularModuleName}) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}type: UPDATE_${singularModuleName.toUpperCase()}_SUCCESS,`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}payload: ${singularModuleName},`;
  reduxActions += `${NEW_LINE + TAB_SPACE}}`;
  reduxActions += `${NEW_LINE}};`;

  reduxActions += NEW_LINE + NEW_LINE;

  reduxActions += `const update${capitalizeFirstLetter(singularModuleName)}Failure = (error) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}type: UPDATE_${singularModuleName.toUpperCase()}_FAILURE,`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}payload: error,`;
  reduxActions += `${NEW_LINE + TAB_SPACE}}`;
  reduxActions += `${NEW_LINE}};`;
  // End fetch update

  return reduxActions;
}

function getReduxDeleteActions(params) {
  const singularModuleName = makeSingular(params.module);
  let reduxActions = "";

  // Start fetch delete
  reduxActions += `export const delete${capitalizeFirstLetter(singularModuleName)} = (id) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return (dispatch) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}dispatch(delete${capitalizeFirstLetter(singularModuleName)}Request());`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}axios`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}.put('${params.apiUrls}/' + id)`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}.then((response) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}const message = response.data;`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}dispatch(delete${capitalizeFirstLetter(
    singularModuleName
  )}Success(message));`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}})`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}.catch((error) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE + TAB_SPACE}dispatch(delete${capitalizeFirstLetter(
    singularModuleName
  )}Failure(error.message));`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE + TAB_SPACE}})`;
  reduxActions += `${NEW_LINE + TAB_SPACE}};`;
  reduxActions += `${NEW_LINE}};`;

  reduxActions += NEW_LINE + NEW_LINE;

  reduxActions += `const delete${capitalizeFirstLetter(singularModuleName)}Request = () => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}type: DELETE_${singularModuleName.toUpperCase()}_REQUEST,`;
  reduxActions += `${NEW_LINE + TAB_SPACE}}`;
  reduxActions += `${NEW_LINE}};`;

  reduxActions += NEW_LINE + NEW_LINE;

  reduxActions += `const delete${capitalizeFirstLetter(singularModuleName)}Success = (${singularModuleName}) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}type: DELETE_${singularModuleName.toUpperCase()}_SUCCESS,`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}payload: ${singularModuleName},`;
  reduxActions += `${NEW_LINE + TAB_SPACE}}`;
  reduxActions += `${NEW_LINE}};`;

  reduxActions += NEW_LINE + NEW_LINE;

  reduxActions += `const delete${capitalizeFirstLetter(singularModuleName)}Failure = (error) => {`;
  reduxActions += `${NEW_LINE + TAB_SPACE}return {`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}type: DELETE_${singularModuleName.toUpperCase()}_FAILURE,`;
  reduxActions += `${NEW_LINE + TAB_SPACE + TAB_SPACE}payload: error,`;
  reduxActions += `${NEW_LINE + TAB_SPACE}}`;
  reduxActions += `${NEW_LINE}};`;
  // End fetch delete

  return reduxActions;
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
